const checkCustomizationModal = () => {
  const hasCustomization = window.teeinblue.hasCustomization(window.TeeInBlueCampaign.productId);
  const modal = document.getElementById('tee_reset_customization');

  if (modal && hasCustomization) {
    modal.style.display = 'block';

    const closeButtons = document.querySelectorAll('[data-close-modal]');
    const resetButtons = document.querySelectorAll('[data-reset-modal]');
    const confirmButtons = document.querySelectorAll('[data-confirm-reset]');

    closeButtons.forEach((button) => button.addEventListener('click', () => (modal.style.display = 'none')));

    resetButtons.forEach((button) =>
      button.addEventListener('click', () => {
        button.disabled = true;
        button.innerHTML =
          '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';
        window.teeinblue.resetCustomization(window.TeeInBlueCampaign.productId);
        modal.style.display = 'none';
      })
    );

    confirmButtons.forEach((button) =>
      button.addEventListener('click', () => {
        button.disabled = true;
        button.innerHTML =
          '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';
        window.teeinblue.refillCustomization(window.TeeInBlueCampaign.productId);
        setTimeout(() => {
          modal.style.display = 'none';
        }, 500);
      })
    );
  }
};

document.addEventListener('teeinblue-event-component-injected', () => {
  checkCustomizationModal();
});
